import { DurationControl } from "./component-ref-duration-control"
import { FrequencyControl } from "./component-ref-frequency-control"

/**
 * Slot plug for TimeAndFrequency.
 *
 * Renders duration and frequency as independently linkable fields.
 * Each gets its own puzzle/link icon and can be linked/unlinked
 * without affecting the other.
 */
export function ComponentRefTimeFrequency() {
    return (
        <>
            <DurationControl />
            <FrequencyControl />
        </>
    )
}
